import * as React from 'react';

function LockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 12 16" fill="none" {...props}>
			<path
				d="M11.299 7.57h-.684V4.79c0-2.415-2.07-4.373-4.623-4.373-2.554 0-4.623 1.958-4.623 4.374V7.57H.684C.3 7.57 0 7.854 0 8.217v6.553c0 .363.3.647.684.647h10.632c.384 0 .684-.284.684-.647V8.217a.685.685 0 00-.701-.647zM6.726 13.3H5.274l.267-1.705c-.284-.158-.484-.442-.484-.758 0-.49.417-.884.935-.884.517 0 .934.395.934.884 0 .332-.2.616-.484.758l.284 1.705zm1.72-5.731H3.537V4.917c0-1.279 1.102-2.321 2.454-2.321s2.453 1.042 2.453 2.321V7.57z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default LockIcon;
